<template>
    <div class="p-6 mb-8 bg-white rounded-lg lg:p-8">
        <p class="mb-6 text-xl font-bold text-primary-500">IX. Subjective Symptoms / 自覚症状</p>
        <div class="mb-4 space-y-1 text-darkgray-800">
            <p>Check if you are experiencing any of the following / 次のいずれかの症状がある場合には、下記のボックスにチェックを入れてください。</p>
            <p
                v-if="errors[`subjective_symptoms`]"
                class="text-[10px] mt-1 text-red-600"
            >
                {{ errors[`subjective_symptoms`][0] }}
            </p>
            <p
                v-if="errors[`subjective_symptoms.experience`]"
                class="text-[10px] mt-1 text-red-600"
            >
                {{ errors[`subjective_symptoms.experience`][0] }}
            </p>
        </div>
        <div class="space-y-3 lg:columns-2">
            <checkbox-input 
                v-for="i in symptoms"
                :key="i"
                :id="i.label"
                :label="i.label"
                :rounded="false"
                :disabled="disableInputs"
                :is-checked="selectedVal.includes(i.value)"
                text-color="text-darkgray-800"
                @change="addSymptom(i.value, selectedVal.includes(i.value))"
            />

            <checkbox-input
                v-model="showOthers"
                id="others"
                :rounded="false"
                :disabled="disableInputs"
                text-color="text-darkgray-800"
                :is-checked="showOthers"
                label="Others /その他"
                />

            <div 
                class="col-span-6 mt-3 pl-7"
            >
                <text-input
                    v-if="showOthers"
                    v-model="others"
                    id="test_result_others"
                    type="text"
                    placeholder="Type here"
                    :error="errors['subjective_symptoms.others_description'] ? errors['subjective_symptoms.others_description'][0] : ''"
                />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import CheckboxInput from '@/components/inputs/CheckboxInput.vue';
import MedicalService from '@/classes/MedicalService';
import TextInput from '@/components/inputs/TextInput.vue';
import { computed, ref, watch, onMounted } from 'vue';

const props = defineProps({
    form: {
        type: Object,
        required: true
    },
    disableInputs: {
        type: Boolean,
        required: false
    },
    errors: {
        type: Array,
        required: true
    },
})

const symptoms = MedicalService.getSymptoms()
const item = ref(props.form)
const others = ref<string>('')
const showOthers = ref<boolean>(false)
const isShowingOthers = ref<boolean>(false);

const selectedVal = computed(() => item.value?.map(a => a.symptoms));



const addSymptom = (symptoms: string, val: boolean) => {
    console.log("Adding symptom:", symptoms, "with value:", val);
    // If "None" is selected, clear all other symptoms
    if (symptoms === "None") {
        console.log("Adding 'None' symptom, clearing others");
        for (let i = item.value.length - 1; i >= 0; i--) {
            item.value.splice(i, 1);
        }
        
        // item.value = [{ symptoms: "None", is_checked: true }];
        if(!val) {
            item.value.push({ symptoms: "None",  is_checked: !val })
        }
        showOthers.value = false;
        isShowingOthers.value = false;
        others.value = '';
        return;
    }
    
    // If any other symptom is selected while "None" is checked, remove "None"
    const noneIndex = item.value.findIndex(i => i.symptoms === "None");
    if (noneIndex !== -1) {
        item.value.splice(noneIndex, 1);
    }

    if(!item.value.some(e => e.symptoms === symptoms)) {
        item.value.push({ symptoms,  is_checked: true })
    } else {
        item.value.splice(item.value.findIndex(i => i.symptoms === symptoms), 1);
    }
}

const othersSymptoms = () => {
    console.log("Updating Others Symptoms with:", others.value);
    const index = item.value.findIndex(i => i.symptoms === "Others");
    if (!props.disableInputs && others.value !== '') {  
    
        if (index != -1) {
            item.value.splice(index, 1);
        } 
        
        item.value.push({ symptoms: "Others", is_checked: true, "others_description": others.value })
    } 
}

watch(
    () => others.value,
    () => {
        if(others.value) {
            othersSymptoms()
        }
    }
);

watch(
    () => showOthers.value,
    () => {
        console.log("showOthers changed:", showOthers.value);
        if (showOthers.value) {
            console.log("showOthers is true");
            item.value.push({ symptoms: "Others", is_checked: true, "others_description": others.value })
        } else {
            console.log("showOthers is false");
            const othersIndex = item.value.findIndex(i => i.symptoms === "Others");
            if (othersIndex !== -1) {
                item.value.splice(othersIndex, 1);
            }
            isShowingOthers.value = false;
            others.value = '';
        }
    }
)

onMounted(() => {
    showOthers.value = item.value.some(i => i.symptoms === "Others");
    isShowingOthers.value = item.value.some(i => i.symptoms === "Others");
    others.value = item.value.find(i => i.symptoms === "Others")?.others_description || '';
});
</script>